import { FormConfig } from '../../components/DynamicForm';

// 设备信息表单配置
export const deviceFormConfig: FormConfig = {
  id: 'device_form',
  name: '设备信息',
  description: '用于录入设备和司机信息',
  fields: [
    {
      key: 'monitorKey',
      label: '安全监控对接密钥',
      type: 'input',
      required: true,
      placeholder: '请输入安全监控对接密钥',
      rules: [
        { required: true, message: '请输入安全监控对接密钥' },
        { min: 32, message: '密钥长度不能少于32位' }
      ]
    },
    {
      key: 'deviceNo',
      label: '出厂编号',
      type: 'input',
      required: true,
      placeholder: '请输入设备出厂编号',
      rules: [
        { required: true, message: '请输入设备出厂编号' }
      ]
    },
    {
      key: 'driverName',
      label: '司机姓名',
      type: 'input',
      required: true,
      placeholder: '请输入司机姓名',
      rules: [
        { required: true, message: '请输入司机姓名' }
      ]
    },
    {
      key: 'idcardNumber',
      label: '司机身份证号码',
      type: 'input',
      required: true,
      placeholder: '请输入司机身份证号码',
      rules: [
        { required: true, message: '请输入司机身份证号码' },
        { 
          pattern: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
          message: '请输入有效的身份证号码' 
        }
      ]
    },
    {
      key: 'recordNo',
      label: '设备备案号',
      type: 'input',
      required: true,
      placeholder: '请输入设备备案号',
      rules: [
        { required: true, message: '请输入设备备案号' }
      ]
    },
    {
      key: 'deviceType',
      label: '设备类型',
      type: 'select',
      required: true,
      placeholder: '请选择设备类型',
      options: [
        { label: '挖掘机', value: 'excavator' },
        { label: '装载机', value: 'loader' },
        { label: '推土机', value: 'bulldozer' },
        { label: '起重机', value: 'crane' },
        { label: '其他', value: 'other' }
      ],
      rules: [
        { required: true, message: '请选择设备类型' }
      ]
    },
    {
      key: 'purchaseDate',
      label: '购买日期',
      type: 'date',
      required: false,
      placeholder: '请选择购买日期',
      props: {
        format: 'YYYY-MM-DD'
      }
    },
    {
      key: 'isActive',
      label: '是否启用',
      type: 'switch',
      required: false,
      defaultValue: true
    },
    {
      key: 'notes',
      label: '备注',
      type: 'textarea',
      required: false,
      placeholder: '请输入备注信息'
    }
  ]
}; 